// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum ConnectorCap {
  None = 0,
  FilledTriangle = 1,
  Arrow = 2,
  Triangle = 3,
  Diamond = 4,
  FilledDiamond = 5,
  Oval = 6,
  FilledOval = 7
}
